import { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

import Modal from '../../shared/Modal';
import text from '../../text.json';
import { removeSensor } from '../../redux/api/sensor';

const RemoveSensor = ({ handleClose, isOpen, data }) => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const handleRemoveSensor = async () => {
    setIsLoading(true);

    const result = await dispatch(removeSensor(data?.id));

    if (result?.error) {
      setIsLoading(false);
    } else {
      handleClose();
    }
  };

  return (
    <Modal
      isDestructive
      isLoading={isLoading}
      handleClose={handleClose}
      isOpen={isOpen}
      primaryButtonText={text.buttons.remove}
      secondaryButtonText={text.buttons.cancel}
      onPrimaryButtonClick={handleRemoveSensor}
      onSecondaryButtonClick={handleClose}
      modalTitle={text.remove.title.replace('{{name}}', data?.name)}
    >
      <Typography>
        {text.removeSensor.description}
      </Typography>
    </Modal>
  );
};

export default RemoveSensor;

RemoveSensor.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  data: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })
};

RemoveSensor.defaultProps = {
  isOpen: false,
  data: {
    id: '',
    name: ''
  }
};
